import React from 'react'
import { useSymbolPrices } from '../../../context/WebSocketContext'

export default function Low({ symbolId, digits }) {
    const { [symbolId]: symbol } = useSymbolPrices();

    return <span>{symbol?.low?.toFixed(digits)}</span>;
}
